import LateralEpisodicCachedEvent from './lateral_episodic_cached_event';
import LarvaCachedEvent from './larva_cached_event';
import Experiment from "shared/experiment";

// TODO: Dead Feature
export class RecommenderPicker {
  constructor(userId = undefined, experimentId = undefined) {
    this.userId       = userId;
    this.experimentId = experimentId;
    this._experiment  = new Experiment(this.experimentId);
  }

  experiment(){
    return this._experiment;
  }

  experimentVariation(){
    return this.experiment().variation();
  }

  pick(){
    var promise = new Promise(function(resolve, reject){
      this.experiment().start().then(function(){
        var recommender = this.recommender(this.experimentVariation());
        resolve(recommender);
      }.bind(this)).catch(function(){
        reject(this.defaultRecommender());
      }.bind(this));
    }.bind(this));

    return promise;
  }

  recommender(variation) {
    var recommender;
    if (variation === 0){
      recommender = new LateralEpisodicCachedEvent('lateral_episodic_cached', this.userId);
    } else {
      recommender = new LarvaCachedEvent('larva_related', this.userId);// jshint ignore:line
    }

    return recommender;
  }

  defaultRecommender(){
    return this.recommender(1);
  }

 initRecommender(recommender, platform, videoId, videoTitle, recoEvent, isLoggedIn = false) {
    var $recoDom   = $("#reco_gravity");
    var loginLabel = isLoggedIn ? "login" : "not login";
    var eventLabel = `${recommender.recoName()}::${platform}::${loginLabel}::${videoId} - ${videoTitle}`;

    recommender.viewVideo(videoId);  // will also show / hide collection sidebar depending on recommender

    recoEvent.setRecommender(recommender.recoName());
    recoEvent.bindClickEvent();
    ga('send', 'event', platform, 'recommender', eventLabel, {nonInteraction: true});

    recommender.getRecommendations(videoId, videoTitle, platform);
    recommender.bindEventRecClick($recoDom);
  }

  isDebugging() {
    var debug = $("#reco_gravity").attr('data-debug-recommender');
    return debug !== undefined && debug !== "";
  }
}
